import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ADMIN_ASSIGN_USER_PERMISSIONS_RIGHT } from 'src/app/extensions/constants/commonConstants';
import { UserAPIService } from 'src/app/extensions/services/api/user-api.service';
import { ROUTES } from '../../../core/constants/routes-constants';

@Component({
  selector: 'admin-user-rights-configurator',
  templateUrl: './admin-user-permission-configurator.component.html',
  styleUrl: './admin-user-permission-configurator.component.scss',
  standalone: false,
})
export class AdminUserPermissionConfiguratorComponent implements OnInit {
  @ViewChild('rightsConfiguratorForm') public form: NgForm;

  userRolesDataModel: app.models.UserRolesDataModel = {} as app.models.UserRolesDataModel;
  userWithoutRoles: boolean = false;
  dataLoaded: boolean = false;

  featuresAndRights: app.models.UserFeaturesAndRights[] = [];
  rightGroups: app.models.RightGroupModel[] = [];

  saveUserRolesModel: app.models.SaveUserRoles = {} as app.models.SaveUserRoles;
  navigation: app.models.UserNavigationState;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _notificationService: NotificationService,
    private _translateService: TranslateService,
    private _userAPIService: UserAPIService,
    private _router: Router
  ) {
    const currentNav = this._router.getCurrentNavigation();
    this.navigation = currentNav.extras.state as app.models.UserNavigationState;
  }

  ngOnInit(): void {
    this.userRolesDataModel.userId = this._activatedRoute.snapshot.params['userId'];

    this._userAPIService.getCurrentUserRights(this.userRolesDataModel.userId).subscribe(userRights => {
      if (!userRights.map(x => x.code).includes(ADMIN_ASSIGN_USER_PERMISSIONS_RIGHT)) {
        this._router.navigate([ROUTES.UNAUTHORIZED_ROUTE_URL]);
      }

      this._userAPIService.getUserRolesData(this.userRolesDataModel.userId).subscribe(userRolesModel => {
        this.userRolesDataModel = userRolesModel;

        if (!userRolesModel.roles.some(x => x)) {
          this.userWithoutRoles = true;
          this.dataLoaded = true;
          return;
        }

        this._userAPIService
          .getFeaturesAndRightsByRole(userRolesModel.roles[0]!.roleId)
          .subscribe(featuresAndRights => {
            this.featuresAndRights = featuresAndRights;
            this.saveUserRolesModel.userId = this.userRolesDataModel.userId;
            this.saveUserRolesModel.roles = this.userRolesDataModel.roles.map(x => {
              return {
                roleId: x.roleId,
                createdOn: x.createdOn,
                permissions: x.permissions,
              } as app.models.RoleModel;
            });

            const userPermissions = this.saveUserRolesModel.roles[0].permissions;
            this.featuresAndRights.forEach(feature => {
              feature.rightGroups.forEach(rightGroup => {
                rightGroup.isSelectedOption =
                  userPermissions.find(x => x.featureId == feature.id && x.rightGroupId == rightGroup.id) != undefined;
              });

              feature.rightGroups.sort(x => (!x.isWrite ? 1 : -1));
              feature.rightGroups.push({
                id: undefined,
                code: undefined,
                value: this._translateService.instant('users.rights.noRights'),
                isSelectedOption: !userPermissions.filter(x => x.featureId == feature.id).some(x => x),
              } as app.models.RightGroupModel);
            });
            this.dataLoaded = true;
          });
      });
    });
  }

  redirectToListHandler() {
    const navigationExtras = {
      state: { ...this.navigation },
    };
    this._router.navigate(['users'], navigationExtras);
  }

  saveUserPermissionsHandler() {
    this._userAPIService.saveUserPermission(this.saveUserRolesModel).subscribe(response => {
      if (response.isSuccess) {
        this._notificationService.showSuccess(
          this._translateService.instant('users.rights.permissionSaved'),
          this._translateService.instant('common.success')
        );
        this.redirectToListHandler();
      }
    });
  }

  mapRightGroupToSaveModelHandler(featureId: string, rightGroupId: string | undefined) {
    this.saveUserRolesModel.roles[0].permissions = this.saveUserRolesModel.roles[0].permissions.filter(
      x => x.featureId != featureId
    );
    if (rightGroupId !== undefined)
      this.saveUserRolesModel.roles[0].permissions.push({
        featureId: featureId,
        rightGroupId: rightGroupId,
      } as app.models.FeatureXRightGroupModel);
  }
}
